/**
 * Decisão de staleness da inbox (fallback independente de WebSocket).
 *
 * O servidor avança `workspace_member_inbox_stats.updated_at` a cada mudança
 * relevante. Se o heartbeat do servidor está à frente da última atividade local
 * (evento Realtime ou fetch) além de uma folga, a lista está defasada.
 */
export function isInboxStale(params: {
  serverHeartbeatAt: string | null;
  lastLocalActivityAtMs: number;
  graceMs?: number;
}): boolean {
  const { serverHeartbeatAt, lastLocalActivityAtMs } = params;
  if (!serverHeartbeatAt) return false;

  const graceMs = params.graceMs ?? 20_000;
  const serverAt = Date.parse(serverHeartbeatAt);
  if (!Number.isFinite(serverAt)) return false;

  return serverAt - graceMs > lastLocalActivityAtMs;
}

/**
 * Realtime saudável — dispensa a checagem no banco.
 * Sem evento ainda, vale o instante em que o canal assinou.
 */
export function isRealtimeHubRecentlyActive(params: {
  joined: boolean;
  lastEventAt: number | null;
  subscribedAt?: number | null;
  now?: number;
  graceMs?: number;
}): boolean {
  if (!params.joined) return false;
  const mark = params.lastEventAt ?? params.subscribedAt ?? null;
  if (mark == null) return false;
  const graceMs = params.graceMs ?? 60_000;
  const now = params.now ?? Date.now();
  return now - mark < graceMs;
}

/** Se uma conversa fechada recebeu mensagem inbound, ela deve reabrir. */
export function shouldClosedConversationReopen(params: {
  isClosed: boolean;
  lastMessageDirection: string | null | undefined;
}): boolean {
  return params.isClosed === true && params.lastMessageDirection === "inbound";
}
